import React, { createContext, useState, useContext, useEffect } from "react";
import PaymentModal from "../components/PaymentModal";
import io from "socket.io-client";
import { useAuth } from "./AuthContext";
import axios from "axios";
import ProfileModal from "../components/ProfileModal";
import AccountHistoryModal from "../components/AccountHistoryModal";
import GameHistoryModal from "../components/GameHistoryModal";
import CurrencyDropdown from "../components/CurrencyDropdown";
import CurrencyChangeWarningModal from "../components/CurrencyChangeWarningModal";
import ReactDOM from "react-dom";
import { useLocation } from "react-router-dom";

import { getApiUrl } from "../utils/config";
const API_URL = getApiUrl();
const PaymentContext = createContext();

export const PaymentProvider = ({ children }) => {
    const location = useLocation();
    const [isOpen, setIsOpen] = useState(false);
    const [amount, setAmount] = useState(null);
    const [extId, setPaymentExtId] = useState(null);
    const [transactionType, setTransactionType] = useState(null);
    const [balanceUsd, setBalanceUsd] = useState(0);
    const [balanceRub, setBalanceRub] = useState(0);
    const [balanceBrl, setBalanceBrl] = useState(0);
    const [balanceUsdt, setBalanceUsdt] = useState(0);
    const [balanceEur, setBalanceEur] = useState(0);
    const [bonusBalanceUsd, setBonusBalanceUsd] = useState(0);
    const [bonusBalanceRub, setBonusBalanceRub] = useState(0);
    const [bonusBalanceBrl, setBonusBalanceBrl] = useState(0);
    const [bonusBalanceUsdt, setBonusBalanceUsdt] = useState(0);
    const [bonusBalanceEur, setBonusBalanceEur] = useState(0);
    const [selectedCurrency, setSelectedCurrency] = useState('USD');
    const [isCurrencyLoaded, setIsCurrencyLoaded] = useState(false);
    const [socket, setSocket] = useState(null);
    const [isSocketConnected, setIsSocketConnected] = useState(false);
    const [httpInterval, setHttpInterval] = useState(null);
    const [isBalanceLoaded, setIsBalanceLoaded] = useState(false);
    const { isAuth, checkAuth } = useAuth();
    const [onPaymentUpdate, setOnPaymentUpdate] = useState(null);

    // Состояния для предупреждения о смене валюты
    const [showCurrencyWarning, setShowCurrencyWarning] = useState(false);
    const [pendingCurrency, setPendingCurrency] = useState(null);
    const [profile, setProfile] = useState({
        username: "",
        phoneNumber: "",
        country: "",
        registration_country: "",
        refPercent: 0,
        MyuserId: null,
        passportPhoto: "",
        birthdate: "",
        email: "",
        emailVerified: false,
        telegram_id: null,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
    });
    const [showProfileModal, setShowProfileModal] = useState(false);
    const [showAccountHistoryModal, setShowAccountHistoryModal] = useState(false);
    const [showGameHistoryModal, setShowGameHistoryModal] = useState(false);

    // Состояние для глобального dropdown валют
    const [globalCurrencyDropdown, setGlobalCurrencyDropdown] = useState({
        isOpen: false,
        position: { x: 0, y: 0 },
        triggerElement: null
    });
    const [cashbackData, setCashbackData] = useState(null);
    const [cashbackDay, setCashbackDay] = useState(null);
    const [bonusCashbackData, setBonusCashbackData] = useState(null);
    const [fiatRates, setFiatRates] = useState({ RUB_USD: null, RUB_BRL: null, USD_BRL: null, USD_RUB: null, BRL_RUB: null, BRL_USD: null });
    const [verificationData, setVerificationData] = useState(null);

    // Устанавливаем isBalanceLoaded в true для неавторизованных пользователей
    useEffect(() => {
        if (!isAuth) {
            setIsBalanceLoaded(true);
        }
    }, [isAuth]);

    // Функция для получения баланса через HTTP
    const fetchBalance = async () => {
        if (!isAuth) return;

        try {
            const response = await fetch(`${API_URL}/api/balance`, {
                method: "GET",
                credentials: "include",
            });
            const data = await response.json();
            if (data.success) {
                setBalanceUsd(data.balanceUsd);
                setBalanceRub(data.balanceRub);
                setBalanceBrl(data.balanceBrl);
                setBalanceUsdt(data.balanceUsdt);
                setBalanceEur(data.balanceEur);
                setBonusBalanceUsd(data.bonusBalanceUsd);
                setBonusBalanceRub(data.bonusBalanceRub);
                setBonusBalanceBrl(data.bonusBalanceBrl);
                setBonusBalanceUsdt(data.bonusBalanceUsdt);
                setBonusBalanceEur(data.bonusBalanceEur);
                setSelectedCurrency(data.selectedCurrency);
                setFiatRates(data.fiatRates || {});
                setIsCurrencyLoaded(true);
                setIsBalanceLoaded(true);
                // Можно добавить experiencePoints если нужно будет использовать в других компонентах
                // setExperiencePoints(data.experiencePoints || 0);
            }
        } catch (error) {
            console.error("Ошибка при получении баланса:", error);
            setIsBalanceLoaded(true);
        }
    };

    // Функция для запуска HTTP-интервала
    const startHttpInterval = () => {
        if (!isAuth) return;

        if (httpInterval) {
            clearInterval(httpInterval);
        }
        fetchBalance();
        const interval = setInterval(fetchBalance, 30000);
        setHttpInterval(interval);
    };

    // Функция для остановки HTTP-интервала
    const stopHttpInterval = () => {
        if (httpInterval) {
            clearInterval(httpInterval);
            setHttpInterval(null);
        }
    };

    // Инициализация WebSocket соединения
    useEffect(() => {
        if (isAuth) {
            console.log("Начало инициализации WebSocket...");
            setIsSocketConnected(false);
            setIsBalanceLoaded(false);

            // Таймер аварийного fallback на HTTP polling если WebSocket не подключился
            const fallbackTimer = setTimeout(() => {
                console.log("⚠️ WebSocket не подключился за 15 секунд - переключаемся на HTTP polling");
                setIsSocketConnected(false);
                setIsBalanceLoaded(true); // Разблокируем загрузку
                startHttpInterval();
            }, 15000);

            const wsUrl = API_URL.replace(/^https?/, 'wss');
            console.log(`🔌 WebSocket URL: ${wsUrl} (из API_URL: ${API_URL})`);
            const newSocket = io(wsUrl, {
                transports: ['websocket', 'polling'],
                path: '/socket.io/',
                withCredentials: true,
                reconnection: true,
                reconnectionAttempts: 5, // Уменьшено с 10 до 5
                reconnectionDelay: 1000,
                reconnectionDelayMax: 5000,
                timeout: 10000, // Уменьшено с 15000 до 10000
                autoConnect: true,
                forceNew: true,
                upgrade: true,
                rememberUpgrade: true,
                connectTimeout: 10000 // Уменьшено с 15000 до 10000
            });

            newSocket.on("connect", () => {
                console.log("✅ WebSocket соединение установлено успешно");
                clearTimeout(fallbackTimer); // Очищаем аварийный таймер
                setIsSocketConnected(true);
                stopHttpInterval();
                fetchBalance();
            });

            newSocket.on("connection_confirmed", (data) => {
                console.log(`✅ WebSocket соединение подтверждено сервером:`, {
                    timestamp: new Date(data.timestamp).toLocaleTimeString(),
                    transport: data.transport
                });
            });

            newSocket.on("balance_update", (data) => {
                console.log("💰 PaymentContext: Получено обновление баланса через WebSocket:", {
                    balanceUsd: data.balanceUsd,
                    balanceRub: data.balanceRub,
                    balanceBrl: data.balanceBrl,
                    balanceUsdt: data.balanceUsdt,
                    balanceEur: data.balanceEur,
                    selectedCurrency: data.selectedCurrency,
                    isInitial: data.initial
                });
                if (data.initial) {
                    fetchBalance();
                } else {
                    setBalanceUsd(data.balanceUsd);
                    setBalanceRub(data.balanceRub);
                    setBalanceBrl(data.balanceBrl);
                    setBalanceUsdt(data.balanceUsdt);
                    setBalanceEur(data.balanceEur);
                    setSelectedCurrency(data.selectedCurrency);
                    setIsBalanceLoaded(true);
                }
            });

            newSocket.on("disconnect", (reason) => {
                console.log("⚠️ WebSocket соединение разорвано. Причина:", reason);
                setIsSocketConnected(false);

                if (reason !== 'io client disconnect') {
                    console.log("🔄 Запускаем HTTP fallback после отключения WebSocket");
                    startHttpInterval();
                }
            });

            newSocket.on("connect_error", (error) => {
                console.error("❌ Ошибка подключения WebSocket:", {
                    message: error.message,
                    type: error.type,
                    description: error.description
                });
                setIsSocketConnected(false);

                console.log("🔄 Запускаем HTTP fallback после ошибки подключения");
                startHttpInterval();

                if (error.message === "Authentication error" || error.message.includes("Authentication")) {
                    console.log("🔒 Ошибка аутентификации, проверяем авторизацию");
                    checkAuth();
                }
            });

            newSocket.on("reconnect", (attemptNumber) => {
                console.log(`🔄 WebSocket переподключен после ${attemptNumber} попыток`);
                setIsSocketConnected(true);
                stopHttpInterval();
                fetchBalance();
            });

            newSocket.on("reconnect_attempt", (attemptNumber) => {
                console.log(`🔄 Попытка переподключения WebSocket #${attemptNumber}`);
            });

            newSocket.on("reconnect_error", (error) => {
                console.error("❌ Ошибка переподключения WebSocket:", error.message);
            });

            newSocket.on("reconnect_failed", () => {
                console.error("❌ Не удалось переподключить WebSocket после всех попыток");
                console.log("🔄 Переключаемся на постоянный HTTP polling");
                stopHttpInterval();
                startHttpInterval();
            });

            newSocket.on("error", (error) => {
                console.error("❌ Общая ошибка WebSocket:", error);
                setIsSocketConnected(false);
            });

            setSocket(newSocket);

            return () => {
                console.log("🧹 Очистка WebSocket соединения");
                clearTimeout(fallbackTimer); // Очищаем аварийный таймер при размонтировании
                setIsSocketConnected(false);
                setIsBalanceLoaded(false);
                stopHttpInterval();
                if (newSocket) {
                    newSocket.close();
                }
            };
        }
    }, [isAuth]);

    useEffect(() => {
        if (isAuth) {
            fetchProfile();
            fetchVerificationStatus();
        }
    }, [isAuth]);

    const closeAllModals = () => {
        setIsOpen(false);
        setShowProfileModal(false);
        setShowAccountHistoryModal(false);
        setShowGameHistoryModal(false);
        setAmount(null);
        setPaymentExtId(null);
        setTransactionType(null);
        setOnPaymentUpdate(null);
    };

    const openPaymentModal = (options = {}) => {
        closeAllModals();
        setAmount(options.amount || null);
        setPaymentExtId(options.extId || null);
        setTransactionType(options.type || null);
        setOnPaymentUpdate(typeof options.onUpdate === 'function' ? options.onUpdate : null);
        setIsOpen(true);
    };

    const closePaymentModal = () => {
        if (typeof onPaymentUpdate === 'function') {
            try {
                onPaymentUpdate();
            } catch (error) {
                console.error('Ошибка при выполнении onPaymentUpdate:', error);
            }
        }
        closeAllModals();
    };

    // Получаем текущий баланс в зависимости от выбранной валюты
    const getCurrentBalance = () => {
        switch (selectedCurrency) {
            case 'USD':
                return balanceUsd;
            case 'RUB':
                return balanceRub;
            case 'BRL':
                return balanceBrl;
            case 'USDT':
                return balanceUsdt;
            case 'EUR':
                return balanceEur;
            default:
                return balanceUsd;
        }
    };

    // Получаем текущий бонусный баланс в зависимости от выбранной валюты
    const getCurrentBonusBalance = () => {
        switch (selectedCurrency) {
            case 'USD':
                return bonusBalanceUsd;
            case 'RUB':
                return bonusBalanceRub;
            case 'BRL':
                return bonusBalanceBrl;
            case 'USDT':
                return bonusBalanceUsdt;
            case 'EUR':
                return bonusBalanceEur;
            default:
                return bonusBalanceUsd;
        }
    };

    const fetchProfile = async () => {
        try {
            const response = await fetch(`${API_URL}/api/profile`, {
                method: "GET",
                credentials: "include",
            });

            const data = await response.json();

            if (data.success) {
                setProfile({
                    username: data.username || "",
                    phoneNumber: data.phoneNumber || "",
                    country: data.country || "",
                    registration_country: data.registration_country || "",
                    refPercent: data.refPercent || 0,
                    MyuserId: data.MyuserId || null,
                    passportPhoto: data.passportPhoto || "",
                    birthdate: data.birthdate || "",
                    email: data.email || "",
                    emailVerified: data.emailVerified || false,
                    telegram_id: data.telegramId || null,
                    timezone: data.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone
                });
            }
        } catch (error) {
            console.error('Ошибка при получении профиля:', error);
        }
    };

    const fetchVerificationStatus = async () => {
        try {
            const response = await fetch(`${API_URL}/api/verification/status`, {
                method: "GET",
                credentials: "include",
            });

            const data = await response.json();

            if (data.success) {
                setVerificationData(data);
            }
        } catch (error) {
            console.error('Ошибка при получении статуса верификации:', error);
        }
    };

    const updateProfile = async (profileData) => {
        try {

            const response = await fetch(`${API_URL}/api/profile/update`, {
                method: "POST",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(profileData)
            });

            const data = await response.json();

            if (data.success) {
                await fetchProfile(); // Обновляем данные профиля после успешного обновления
                return { success: true };
            }
            return { success: false, message: data.message };
        } catch (error) {
            console.error('Ошибка при обновлении профиля:', error);
            return {
                success: false,
                message: error.response?.data?.message || 'Ошибка при обновлении профиля'
            };
        }
    };

    // Методы для открытия/закрытия модалок
    const openProfileModal = () => {
        closeAllModals();
        setShowProfileModal(true);
    };

    const closeProfileModal = () => {
        setShowProfileModal(false);
    };

    const openAccountHistoryModal = () => {
        closeAllModals();
        setShowAccountHistoryModal(true);
    };

    const closeAccountHistoryModal = () => {
        setShowAccountHistoryModal(false);
    };

    const openGameHistoryModal = () => {
        closeAllModals();
        setShowGameHistoryModal(true);
    };

    const closeGameHistoryModal = () => {
        setShowGameHistoryModal(false);
    };

    // Функции для управления глобальным dropdown валют
    const openGlobalCurrencyDropdown = (triggerElement) => {
        if (!triggerElement) return;

        console.log('openGlobalCurrencyDropdown called with:', triggerElement);

        const rect = triggerElement.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        const dropdownHeight = 400; // Примерная высота dropdown

        // Определяем, показывать ли dropdown сверху или снизу
        const showAbove = rect.bottom + dropdownHeight > windowHeight && rect.top > dropdownHeight;

        const position = {
            x: rect.left - rect.width / 2,
            y: showAbove ? rect.top - 8 : rect.bottom + 8,
            showAbove
        };

        setGlobalCurrencyDropdown({
            isOpen: true,
            position,
            triggerElement
        });
    };

    const closeGlobalCurrencyDropdown = () => {
        setGlobalCurrencyDropdown({
            isOpen: false,
            position: { x: 0, y: 0 },
            triggerElement: null
        });
    };

    // Функция для определения, находимся ли мы на игровой странице
    const isOnGamePage = () => {
        return location.pathname.includes('/game/') ||
            location.pathname.includes('/gis-game/');
    };

    // Обработчик смены валюты с проверкой игровой страницы
    const handleGlobalCurrencyChange = async (currency) => {
        // Если мы на игровой странице, показываем предупреждение
        if (isOnGamePage()) {
            setPendingCurrency(currency);
            setShowCurrencyWarning(true);
            closeGlobalCurrencyDropdown();
            return;
        }

        // Обычная смена валюты для других страниц
        try {
            const result = await updateProfile({ selectedCurrency: currency });
            if (result.success) {
                setSelectedCurrency(currency);
            }
        } finally {
            closeGlobalCurrencyDropdown();
        }
    };

    // Подтверждение смены валюты на игровой странице
    const confirmCurrencyChange = async () => {
        try {
            const result = await updateProfile({ selectedCurrency: pendingCurrency });
            if (result.success) {
                setSelectedCurrency(pendingCurrency);
                // Перезагружаем страницу для новой игровой сессии
                window.location.reload();
            }
        } catch (error) {
            console.error('Ошибка при смене валюты:', error);
        } finally {
            setShowCurrencyWarning(false);
            setPendingCurrency(null);
        }
    };

    // Отмена смены валюты
    const cancelCurrencyChange = () => {
        setShowCurrencyWarning(false);
        setPendingCurrency(null);
    };

    // Закрытие dropdown при клике вне его
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (globalCurrencyDropdown.isOpen && globalCurrencyDropdown.triggerElement) {
                const dropdownElement = document.querySelector('.global-currency-dropdown');
                if (dropdownElement && !dropdownElement.contains(event.target) &&
                    !globalCurrencyDropdown.triggerElement.contains(event.target)) {
                    closeGlobalCurrencyDropdown();
                }
            }
        };

        if (globalCurrencyDropdown.isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [globalCurrencyDropdown.isOpen, globalCurrencyDropdown.triggerElement]);

    // Получить данные кешбека с бэка
    const fetchCashbackData = async (currency = selectedCurrency) => {
        try {
            const response = await fetch(`${API_URL}/api/weekly-cashback?currency=${currency}`, {
                method: "GET",
                credentials: "include",
            });
            const data = await response.json();
            if (data.success) {
                setCashbackData(data);
                return data;
            } else {
                setCashbackData(null);
                return null;
            }
        } catch (error) {
            console.error("Ошибка при получении данных кешбека:", error);
            setCashbackData(null);
            return null;
        }
    };

    // Загружаем кешбек при авторизации и смене валюты
    // Удаляем useEffect, которые вызывают fetchCashbackData(selectedCurrency) и fetchBonusCashbackData(selectedCurrency) при авторизации и смене валюты

    const fetchCashbackDay = async () => {
        try {
            const response = await fetch(`${API_URL}/api/cashback-config`, { credentials: "include" });
            const data = await response.json();
            if (data.success && typeof data.cashbackDay === 'number') {
                setCashbackDay(data.cashbackDay);
                return data.cashbackDay;
            }
        } catch (e) {
            setCashbackDay(null);
        }
        return null;
    };

    useEffect(() => {
        fetchCashbackDay();
    }, []);

    // Получить данные бонусного кешбека с бэка
    const fetchBonusCashbackData = async (currency = selectedCurrency) => {
        try {
            const response = await fetch(`${API_URL}/api/bonus-cashback?currency=${currency}`, {
                method: "GET",
                credentials: "include",
            });
            const data = await response.json();
            if (data.success) {
                setBonusCashbackData(data);
                return data;
            } else {
                setBonusCashbackData(null);
                return null;
            }
        } catch (error) {
            console.error("Ошибка при получении данных бонусного кешбека:", error);
            setBonusCashbackData(null);
            return null;
        }
    };

    // Загружаем бонусный кешбек при авторизации и смене валюты
    // Удаляем useEffect, который вызывает fetchBonusCashbackData(selectedCurrency) при авторизации и смене валюты

    // Загружаем курсы валют при загрузке сайта и при смене валюты
    useEffect(() => {
        const fetchFiatRates = async () => {
            try {
                const response = await fetch(`${API_URL}/api/fiat-rates`);
                const data = await response.json();
                if (data.success && data.rates) {
                    setFiatRates(data.rates);
                }
            } catch (e) {
                // Можно добавить дефолтные значения или оставить старые
            }
        };
        fetchFiatRates();
    }, [selectedCurrency]);

    // Сброс isCurrencyLoaded при логауте
    useEffect(() => {
        if (!isAuth) {
            setIsCurrencyLoaded(false);
        }
    }, [isAuth]);

    return (
        <PaymentContext.Provider value={{
            openPaymentModal,
            closePaymentModal,
            balanceUsd,
            balanceRub,
            balanceBrl,
            balanceUsdt,
            balanceEur,
            bonusBalanceUsd,
            bonusBalanceRub,
            bonusBalanceBrl,
            bonusBalanceUsdt,
            bonusBalanceEur,
            selectedCurrency,
            setSelectedCurrency,
            getCurrentBalance,
            getCurrentBonusBalance,
            fetchBalance,
            isSocketConnected,
            isBalanceLoaded,
            profile,
            fetchProfile,
            updateProfile,
            openProfileModal,
            closeProfileModal,
            openAccountHistoryModal,
            closeAccountHistoryModal,
            openGameHistoryModal,
            closeGameHistoryModal,
            cashbackData,
            fetchCashbackData,
            cashbackDay,
            fetchCashbackDay,
            bonusCashbackData,
            fetchBonusCashbackData,
            fiatRates,
            isCurrencyLoaded,
            // Верификация
            verificationData,
            fetchVerificationStatus,
            // Глобальный dropdown валют
            globalCurrencyDropdown,
            openGlobalCurrencyDropdown,
            closeGlobalCurrencyDropdown,
            handleGlobalCurrencyChange,
            // Предупреждение о смене валюты
            isOnGamePage,
            confirmCurrencyChange,
            cancelCurrencyChange
        }}>
            {children}
            {isOpen && <PaymentModal
                extId={extId}
                transactionType={transactionType}
                selectedCurrency={selectedCurrency}
                onClose={closePaymentModal}
            />}
            {showProfileModal && ReactDOM.createPortal(
                <ProfileModal onClose={closeProfileModal} />, document.body
            )}
            {showAccountHistoryModal && ReactDOM.createPortal(
                <AccountHistoryModal onClose={closeAccountHistoryModal} />, document.body
            )}
            {showGameHistoryModal && ReactDOM.createPortal(
                <GameHistoryModal onClose={closeGameHistoryModal} />, document.body
            )}
            {/* Глобальный dropdown валют */}
            {globalCurrencyDropdown.isOpen && (
                <div
                    className="global-currency-dropdown"
                    style={{
                        position: 'fixed',
                        left: globalCurrencyDropdown.position.x,
                        top: globalCurrencyDropdown.position.y,
                        transform: globalCurrencyDropdown.position.showAbove
                            ? 'translateX(-50%) translateY(-100%)'
                            : 'translateX(-50%)',
                        zIndex: 9999
                    }}
                >
                    <CurrencyDropdown
                        currentCurrency={selectedCurrency}
                        onSelect={handleGlobalCurrencyChange}
                        onClose={closeGlobalCurrencyDropdown}
                    />
                </div>
            )}

            {/* Модальное окно предупреждения о смене валюты */}
            {showCurrencyWarning && pendingCurrency && ReactDOM.createPortal(
                <CurrencyChangeWarningModal
                    currentCurrency={selectedCurrency}
                    newCurrency={pendingCurrency}
                    onConfirm={confirmCurrencyChange}
                    onCancel={cancelCurrencyChange}
                />,
                document.body
            )}
        </PaymentContext.Provider>
    );
};

export const usePayment = () => useContext(PaymentContext);
